/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:11:26
 * @LastEditors: xgx
 * @LastEditTime: 2023-02-21 10:51:00
 */
import req from "@/utils/request";

//  获取列表数据
export const organTree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const create = (params) => req.post("/manager-service/m/organization/create", params);
export const update = (params) => req.post("/manager-service/m/organization/update", params);
export const up = (params) => req.post("/manager-service/m/organization/up", params);
export const down = (params) => req.post("/manager-service/m/organization/down", params);
export const deleteFn = (params) => req.post("/manager-service/m/organization/delete", params);
export const list = (params) => req.post("/manager-service/m/management/list", params);
export const roleList = (params) => req.post("/manager-service/m/role/list", params);
export const deleteOne = (params) => req.post("/manager-service/m/management/delete", params);
export const siteTree = (params) => req.post("/site-service/m/site/tree", params);
export const selectListByOrgId = (params) => req.post("/site-service/m/organSite/selectListByOrgId", params);
export const saveConfig = (params) => req.post("/site-service/m/organSite/saveConfig", params);
export const columnTree = (params) => req.post("/site-service/m/site/column/tree", params);
export const selectListBySiteId = (params) => req.post("/site-service/m/siteColumnConfig/selectListBySiteId", params);
export const siteSaveConfig = (params) => req.post("/site-service/m/siteColumnConfig/saveConfig", params);
export const selectSiteListByOrgId = (params) => req.post("/site-service/m/organSite/selectSiteListByOrgId", params);
export const selectManuscriptListByOrgId = (params) => req.post("/site-service/m/manuscriptSiteConfig/selectListByOrgId", params);
export const saveManuscriptConfig = (params) => req.post("/site-service/m/manuscriptSiteConfig/saveConfig", params);